import { ContentWidthEnum } from 'common/types/styleTypes'
import React, { ReactNode } from 'react'
import { WebsitePageBodyContainer } from 'src/shared/entities/website-page-body/ui/website-page-body-container'

export interface CommonWebsitePageBodyProps {
  htmlAttrId: string
  children: ReactNode
  contentWidth: ContentWidthEnum | undefined
  background: string | undefined
}

export const CommonWebsitePageBody = ({
  htmlAttrId,
  children,
  contentWidth = ContentWidthEnum.m,
  background,
}: CommonWebsitePageBodyProps) => {
  return (
    <WebsitePageBodyContainer
      id={htmlAttrId}
      contentWidth={contentWidth}
      background={background}
    >
      {children}
    </WebsitePageBodyContainer>
  )
}
